module.exports = __webpack_public_path__ + "img/fashion_25.e5b6e2f7.jpg";